import { loadState, saveState } from '../../../libs/persist';

const STORE_KEY = 'auth';
var loaded = loadState(STORE_KEY) || [];

const state = {
	regId: loaded.regId || '',

	authData: loaded.authData || [],
	authToken: loaded.authToken,
	refreshToken: loaded.refreshToken,
	isAuthenticated: loaded.isAuthenticated || false,
	purchaseType: loaded.purchaseType,
	isPasswordReset: loaded.isPasswordReset || false,
	forgotPasswordRef: loaded.forgotPasswordRef || '',
};

const mutations = {
	SET_REG_ID(state, id) {
		state.regId = id;
		saveState(STORE_KEY, state);
	},
	SET_AUTH_TOKEN(state, token) {
		state.authToken = token;
		saveState(STORE_KEY, state);
	},
	SET_REFRESH_TOKEN(state, token) {
		state.refreshToken = token;
		saveState(STORE_KEY, state);
	},
	SET_AUTH_DATA(state, data) {
		state.authData = data;
		saveState(STORE_KEY, state);
	},
	SET_IS_AUTHENTICATED(state, data) {
		state.isAuthenticated = data;
		saveState(STORE_KEY, state);
	},
	SET_PURCHASE_TYPE(state, data) {
		state.purchaseType = data;
		saveState(STORE_KEY, state);
	},
	SET_ISPASSWORD_RESET(state, data) {
		state.isPasswordReset = data;
		saveState(STORE_KEY, state);
	},
	SET_PASSWORD_REF(state, ref) {
		state.forgotPasswordRef = ref;
		saveState(STORE_KEY, state);
	},
};
const actions = {
	setRegId({ commit }, data) {
		commit('SET_REG_ID', data);
	},
	setAuthToken({ commit }, token) {
		commit('SET_AUTH_TOKEN', token);
	},
	setRefreshToken({ commit }, token) {
		commit('SET_REFRESH_TOKEN', token);
	},
	setAuthData({ commit }, data) {
		commit('SET_AUTH_DATA', data);
	},
	setIsAuthenticated({ commit }, data) {
		commit('SET_IS_AUTHENTICATED', data);
	},
	setPurchaseType({ commit }, type) {
		commit('SET_PURCHASE_TYPE', type);
	},
	setIsPasswordReset({ commit }, data) {
		commit('SET_ISPASSWORD_RESET', data);
	},
	setPasswordRef({ commit }, ref) {
		commit('SET_PASSWORD_REF', ref);
	},
	logout({ commit }) {
		commit('SET_REG_ID', '');
		commit('SET_AUTH_TOKEN', null);
		commit('SET_REFRESH_TOKEN', null);
		commit('SET_AUTH_DATA', []);
		commit('SET_IS_AUTHENTICATED', false);
		commit('SET_PURCHASE_TYPE', null);

		saveState(STORE_KEY, {});
	},
};

const getters = {
	selectRegId: (state) => state.regId,
	selectAuthData: (state) => state.authData,
	getAuthToken: (state) => state.authToken,
	getRefreshToken: (state) => state.refreshToken,
	isAuthenticated: (state) => state.isAuthenticated,
	selectPurchaseType: (state) => state.purchaseType,
	isPasswordReset: (state) => state.isPasswordReset,
	forgotPasswordRef: (state) => state.forgotPasswordRef,
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
